import { LocalSettings } from "./context";

export const LOCAL_SETTINGS_KEY = "__local_settings__";

export const defaultLocalSettings: LocalSettings = {
  allowLayoutEdit: true,
  automaticallyPrintReceipts: true,
  salesQueueEnabled: true,
  integratedTyroReceiptPrinting: true,
  integratedTyroSurcharge: false,
  printMerchantReceipt: false,
  automaticallyCompleteSale: false,
  useTyroSimulator: true,
  scannerMode: false,
  cartPosition: "left",
  navigationPosition: "top",
  stockcountDestinationEmail: "",
};
